import { queueApi } from "./queue.api";

export const {
  useGetQueueByCompanyAndShippingCompanyQuery,
  useLazyGetQueueByCompanyAndShippingCompanyQuery,
  useGetQueueDriverPositionsQuery,
  useLazyGetQueueDriverPositionsQuery,
  useResetQueueMutation,
  useCreateDelayQueueMutation
} = queueApi;
